"use client";

import React from "react";

//Styles
import { DescriptionProps } from "@/types";

//Style
import * as S from "./styles";

const Description: React.FC<DescriptionProps> = ({
  className,
  Description,
}) => {
  return (
    <S.DescriptionText className={className}>{Description}</S.DescriptionText>
  );
};

export default Description;
